import React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import cookie from 'js-cookie';
import Home from 'src/Containers/Home';
import Login from 'src/Containers/Login';
import AddTransaction from 'src/Containers/AddTransaction';
import Reports from 'src/Containers/Reports';

const PrivateRoute = ({ ...rest }) => {
	if (!cookie.get('jwt')) {
		return <Redirect to='/login' />;
	}
	return <Route {...rest} />;
};

const Routes: React.FC = () => {
	const location = useLocation();

	return (
		<>
			<TransitionGroup component={null}>
				<CSSTransition
					key={location.pathname}
					timeout={{
						enter: 50,
						exit: 50,
					}}
					classNames='simpleFade'
				>
					<Switch location={location}>
						<Route path='/login' exact component={Login} />
						<PrivateRoute path='/' exact component={Home} />
						<PrivateRoute
							path='/add'
							exact
							component={AddTransaction}
						/>
						<PrivateRoute
							path='/reports'
							exact
							component={Reports}
						/>
					</Switch>
				</CSSTransition>
			</TransitionGroup>
		</>
	);
};

export default Routes;
